// src/shared/telemetry/TelemetryErrorBanner.tsx
// ────────────────────────────────────────────────────────────────────────────
// Fault-isolated error banner — domain-aware layered error messages.
// Shared across all telemetry dashboards.
// ────────────────────────────────────────────────────────────────────────────

import React from 'react'
import { FAULT_LABELS } from './types'

export interface TelemetryErrorBannerProps {
  fault: string | null
  message: string
}

export default function TelemetryErrorBanner({ fault, message }: TelemetryErrorBannerProps) {
  const info = FAULT_LABELS[fault || ''] || FAULT_LABELS.upstream
  return (
    <div className="mx-2 mt-2 rounded-lg border border-red-500/20 bg-red-950/30 p-4 text-sm">
      <div className="flex items-start gap-3">
        <span className="text-lg leading-none">{info.icon}</span>
        <div className="flex-1 min-w-0">
          <p className="text-red-400 font-medium">{info.title}</p>
          <p className="text-red-400/70 mt-1">{message}</p>
          <p className="text-neutral-500 mt-2 text-xs">{info.hint}</p>
        </div>
        {fault && (
          <span className="shrink-0 rounded bg-red-900/40 px-2 py-0.5 text-[10px] font-mono text-red-400/60 uppercase">
            {fault}
          </span>
        )}
      </div>
    </div>
  )
}
